exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".item-title[data-v-4b6c17c4]{font-size:14px;font-weight:bolder}.item-desc[data-v-4b6c17c4]{font-size:10px;color:#aaa}.grid-count-num[data-v-4b6c17c4]{font-size:16px;color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4b6c17c4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/count/table/customerRatioProgress.vue
// module id = 1632
// module chunks = 0